import LogUtils from "./LogUtils";
import DenounceStatusService from '../services/DenounceStatusService';

class StringUtils {

  constructor() {
    this.TAG = "StringUtils";
    this.logUtils = new LogUtils();
    this.denounceStatusService = new DenounceStatusService();
  }

  capitalizeFirstLetter(str) {
    try {
      return str.charAt(0).toUpperCase() + str.slice(1);

    } catch (err) {
      this.logUtils.logErrorMsg(this.TAG, "unabled to capitalizeFirstLetter", err);
    }

    return null;
  }

  isValidCPF(strCPF, isMandatory) {
    try {
      let sum = 0;
      let rest;

      if (!isMandatory && !strCPF) {
        return true;
      }

      if (!strCPF) {
        return false;
      }

      if (strCPF === "00000000000") {
        return false;
      }

      for (let i = 1; i <= 9; i++) {
        sum = sum + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
      }

      rest = (sum * 10) % 11;

      if ((rest === 10) || (rest === 11)) {
        rest = 0;
      }

      if (rest !== parseInt(strCPF.substring(9, 10))) {
        return false;
      }

      sum = 0;

      for (let i = 1; i <= 10; i++) {
        sum = sum + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
      }

      rest = (sum * 10) % 11;

      if ((rest === 10) || (rest === 11)) {
        rest = 0;
      }

      if (rest !== parseInt(strCPF.substring(10, 11))) {
        return false;
      }

      return true;

    } catch (err) {
      this.logUtils.logErrorMsg(this.TAG, "Failed on isValidCPF", err);
    }

    return false;
  }

  isValidPhone(strPhone, isMandatory) {
    try {

      if (!isMandatory && !strPhone) {
        return true;
      }

      if (!strPhone) {
        return false;
      }

      const validPhoneRegex = new RegExp('(\\(?\\d{2}\\)?\\s)?(\\d{4,5}\\-\\d{4})', 'g');

      if (!validPhoneRegex.test(strPhone)) {
        return false;
      }

      return true;

    } catch (err) {
      this.logUtils.logErrorMsg(this.TAG, "Failed on isValidPhone", err);
    }

    return false;
  }

  getPhoneMask() {
    return ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  }

  getCEPMask() {
    return [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
  }

  getCNPJMask() {
    return [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];
  }

  getFullName({firstName, lastName}) {
    if (!firstName) return '';
    return `${firstName}${lastName ? ` ${lastName}` : ''}`;
  }

  getPrettyAddress({ city, address }) {
    if (!city || !address) return null;

    const street = address?.street;
    const number = address?.number;
    const neighborhood = address?.neighborhood;

    return `${street} - ${number}, ${neighborhood}, ${city}`;
  }

  getPrettyDateTime(timestamp) {
    try {
      if (!timestamp) return null;

      const dateTime = new Date(timestamp);
      const day = dateTime.getDate();
      const month = dateTime.getMonth() + 1;
      const year = dateTime.getFullYear();
      const hour = dateTime.getHours();
      const minutes = dateTime.getMinutes();

      return `${day}/${month}/${year} - ${hour}:${minutes}`;

    } catch (err) {
      this.logUtils.logErrorMsg(this.TAG, "Unable to getPrettyDateTime", err);
    }

    return timestamp;
  }

  getPrettyDenounceStatus(denounceStatusName) {
    const denounceStatus = this.denounceStatusService.DENOUNCE_STATUS_NAME_OBJS[denounceStatusName];
    return denounceStatus?.prettyName || denounceStatusName;
  }

}

const stringUtils = new StringUtils();

export default stringUtils;